import React from "react";
import FocalLengthWrapper from "./FocalLengthWrapper";
import { FocalLengthProps } from "../../types/interfaces";
import LanguageContextProvider from "../../utils/context/languageContext";
import { ConfigProvider } from "../../utils/context/configContext";

export const FocalLength: React.FC<FocalLengthProps> = ({
  onComplete,
  config,
}: FocalLengthProps) => {
  return (
    <LanguageContextProvider>
      <ConfigProvider config={config}>
        <FocalLengthWrapper
          onComplete={onComplete}
        />
      </ConfigProvider>
    </LanguageContextProvider>
  );
};
